export function createEmptyTopic(parentId = null) {
  return {
    id: `topic-${Date.now()}`,
    parentId,
    title: "",
  };
}

export function getTopicChildren(topics, parentId = null) {
  const normalizedParent = parentId ?? null;
  return (topics ?? []).filter(
    (topic) => (topic.parentId ?? null) === normalizedParent,
  );
}

export function topicHasChildren(topics, topicId) {
  return getTopicChildren(topics, topicId).length > 0;
}

export function collectTopicDescendantIds(topics, topicId) {
  const ids = new Set([topicId]);
  const walk = (parentId) => {
    getTopicChildren(topics, parentId).forEach((child) => {
      ids.add(child.id);
      walk(child.id);
    });
  };
  walk(topicId);
  return ids;
}

export function getRootTopics(topics) {
  return getTopicChildren(topics, null);
}

export function getTopicRootId(topics, topicId) {
  const path = getTopicPath(topics, topicId);
  return path[0]?.id ?? topicId ?? null;
}

export function readPersistedKbTopics(game) {
  const rawTopics = Array.isArray(game?.kbTopics) ? game.kbTopics : [];
  if (!rawTopics.length) {
    return normalizeKbData(game).topics;
  }

  return rawTopics.map((topic) => ({
    id: String(topic.id),
    parentId: topic.parentId ?? null,
    title: String(topic.title ?? "").trim(),
  }));
}

export function getTopicPath(topics, topicId) {
  const path = [];
  let currentId = topicId;
  while (currentId) {
    const lookupId = currentId;
    const current = topics.find((topic) => topic.id === lookupId);
    if (!current) break;
    path.unshift(current);
    currentId = current.parentId ?? null;
  }
  return path;
}

export function normalizeKbData(game) {
  const rawTopics = Array.isArray(game?.kbTopics) ? game.kbTopics : [];
  let topics = rawTopics.map((topic) => ({
    id: String(topic.id),
    parentId: topic.parentId ?? null,
    title: String(topic.title ?? "").trim(),
  }));

  let items = (game?.kbItems ?? []).map((item) => ({
    ...item,
    topicId: item.topicId ?? null,
  }));

  if (!topics.length) {
    const legacyTitle = (game?.kbTheme || "").trim() || "Общее";
    const rootId = `topic-root-${game?._id ?? "legacy"}`;
    topics = [{ id: rootId, parentId: null, title: legacyTitle }];
    items = items.map((item) => ({
      ...item,
      topicId: item.topicId || rootId,
    }));
  }

  return { topics, items };
}
